import React from "react";
import { useEffect, useState, useRef } from "react";
import { getwithdrawalsbyfilereference ,regenerateabafile} from "../../../../components/CommonSection/apiresources";
import { GetCookie } from "../../../../components/CommonSection/Cookie/Session";
import { makeRequestWithSpinner } from "../../../../Utilities/client";
import { useSpinnerContext } from "../../../../Utilities/SpinnerContext";
import "../../../../components/Dashboard/Dashboard-agent/AgentList.css";
import { ActionStatus } from "../../../../Utilities/enum";
import { addParametersForProfiles } from "../../../../Utilities/profileManagement";
import SubNav from "../../../navbar/subNav";
import AntdTableExample from "../../../input-components/dataTable";
import { message ,Dropdown,Button} from 'antd';
import ToastAlert from "../../../../components/CommonSection/ToastAlert/ToastAlert";
import { format } from 'date-fns';
import "../WithDrawals/withdrawal.css"


const WithDrawalsBatch = () => {
    const [withdrawLists, setWithdrawLists] = useState([]);
    const [userId, setUserId] = useState("");
    const [agencyID, setAgencyId] = useState("");
    const [searchText, setSearchText] = useState("");
    const [purpose, setPurpose] = useState(4);
    const { showSpinner, hideSpinner } = useSpinnerContext();
    const [rows, setRows] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowIds, setRowIds] = useState("");
    const ToastRef = useRef();
    var url = new URL(window.location.href);
    var Paymentmethod = url.searchParams.get("Paymentmethod");
    var FileReference = url.searchParams.get("FileReference");


    useEffect(() => {
        const retrieveData = async () => {
            try {
                const userData = GetCookie("@UserData");
                if (userData) {
                    const parsedData = JSON.parse(userData);
                    setUserId(parsedData.userId);
                    setAgencyId(parsedData.agencyID);
                }
            } catch (error) {
                console.error("Error retrieving data from AsyncStorage:", error);
            }
        };
        retrieveData();
    }, [userId]);

    useEffect(() => {
        if (userId) getWithdrawalsList(1, 10);
    }, [userId, searchText, purpose]);


    const getWithdrawalsList = (currentPage, totalRows) => {
        const baseUrl = getwithdrawalsbyfilereference ;
        let data = {
            FileReference: parseInt(FileReference),
            PaymentMethod: parseInt(Paymentmethod),
        };

        data = addParametersForProfiles(data);
        makeRequestWithSpinner(showSpinner, hideSpinner, baseUrl, "post", data)
            .then((response) => {
                if (response.status === ActionStatus.Successfull) {
                    let withdrawData = response.list;
                        let withdrawList = withdrawData
                        .map((dis) => ({
                            created: format(new Date(dis.createdAt), 'dd/MM/yyyy'),
                            Payee: dis.payee,
                            bsb: dis.accountBSB,
                            "Account #": dis.accountNumber,
                            Amount: dis.amount,
                            Completed:'-',
                        }));
                    setWithdrawLists(withdrawList);
                    
                } else {
                    message.error(response.message)
                }
            })
    };


    // Handler for page change
    const handlePageChange = (pageNumber, totalRows) => {
        setCurrentPage(pageNumber);
        setRows(totalRows);
        getSupportList(pageNumber, totalRows);
    };

    const tabColumns = {
        Completed: {
            colorMap: {
                "Yes": "#00A5A2",
                "No": "#E5A000",
            },
            defaultColor: 'blue'
        }
    };

    const handleSearchValueChange = (value) => {
        setSearchText(value);
    };
        
    const handleRegenarateBatch = () => {
        const baseUrl = regenerateabafile;
        let data = {
            FileReference: parseInt(FileReference),
            PaymentMethod: parseInt(Paymentmethod),
            AgencyId: agencyID
        };
        data = addParametersForProfiles(data);
        showSpinner();
        fetch(baseUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data)
        })
            .then(async (res) => {
                if (!res.ok) {
                    throw new Error("Failed to generate ABA file");
                }
                // Get filename from header if available
                const disposition = res.headers.get("Content-Disposition");
                let fileName = "disbursement.aba";
                if (disposition) {
                    // Try to get UTF-8 filename*= first
                    const utf8Match = disposition.match(/filename\*\=UTF-8''([^;]+)/);
                    const fallbackMatch = disposition.match(/filename="?([^"]+)"?/);

                    if (utf8Match?.[1]) {
                        fileName = decodeURIComponent(utf8Match[1]);
                    } else if (fallbackMatch?.[1]) {
                        fileName = fallbackMatch[1];
                    }
                }
                const blob = await res.blob();
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = fileName;
                document.body.appendChild(a);
                a.click();
                a.remove();
                window.URL.revokeObjectURL(url);
                ToastRef.current.notify(["success", "ABA file downloaded successfully"]);
                getWithdrawalsList(1, 10);
            })
            .catch(() => {
                ToastRef.current.notify(["error", "Failed to download ABA file"]);
            })
            .finally(() => {
                hideSpinner();
            });
    };
  
    const items = [
        {
          key: '1',
          label: (
            <a onClick={handleRegenarateBatch}>
              Regenarate Batch File
            </a>
          ),
        },
        {
          key: '2',
          label: (
            <a>
              Cancel Batch
            </a>
          ),
        },
      ];  


    return (
        <div>
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 px-0 changedateantdstyle">
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 px-0 daily-date-style">
                    <SubNav title={"Batch Withdrawals"} goback={true} extraData={true} extraContent={
                        <div className="mr-2">
                       
                        </div>
                    } />
                    <div className="material-work-desk-new bg-white m-3">
                    <ToastAlert ref={ToastRef} />
                    <div className="ml-4">
                            <Dropdown menu={{ items:items }} placement="bottom" className="mr-2">
                                <Button className="mr-2 withdraw-btn">Actions</Button>
                            </Dropdown>
                            <Button className="mr-2 withdraw-btn">Report</Button>
                        </div>
                        <AntdTableExample
                            label="List Withdrawals Batch"
                            dataSource={withdrawLists}
                            globalSearch
                            hideCol={"id"}
                            onPageChange={handlePageChange}
                            currentPage={currentPage}
                            totalRows={rows}
                            tagColumns={tabColumns}
                            onSearchValueChange={handleSearchValueChange}
                            initialSelectedRowKeys={rowIds}

                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WithDrawalsBatch;
